/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WinProbabilityRequest } from '../models/WinProbabilityRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RatingsService {
    /**
     * Calculate Win Probabilities
     * Calculate win probabilities for teams based on current player ratings (pre-play calculation)
     * @returns number Successful Response
     * @throws ApiError
     */
    public static calculateWinProbabilitiesWinProbabilitiesCalculatePost({
        requestBody,
    }: {
        requestBody: WinProbabilityRequest,
    }): CancelablePromise<Record<string, number>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/win-probabilities/calculate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request - invalid teams or players`,
                500: `Server error`,
            },
        });
    }
}
